export default __webpack_public_path__ + "static/media/tt.dc250d6a.svg";